"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _AlertDialogModule = _interopRequireDefault(require("./AlertDialog.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # Alert Dialog
 * Foodbomb Alert Dialog
 *
 * ### Variants
 * ```
 * ['warning', 'error', 'confirm']
 * ```
 *
 * ## PropTypes:
 * ```js
 * JoinedToggleButton.propTypes = {
 *  variant: PropTypes.oneOf(Object.values(ALERT_TYPES)),
 *  emoji: PropTypes.string,
 *  alertMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
 *  alertTitle: PropTypes.string,
 *  confirmMessage: PropTypes.string,
 *  cancelMessage: PropTypes.string,
 *  isOpen: PropTypes.bool.isRequired,
 *  handleClose: PropTypes.func.isRequired,
 *  handleConfirm: PropTypes.func.isRequired,
 *  disableConfirm: PropTypes.bool,
 *  hideButtons: PropTypes.bool,
 *  hideEmoji: PropTypes.bool,
 * };
 * ```
 *
 * ## Example
 * ```js
 *  <AlertDialog
 *    variant={'warning'}
 *    alertTitle={'Delete card'}
 *    isOpen={confirmDeleteDialogOpen}
 *    handleClose={this.closeConfirmDeleteDialog}
 *    handleConfirm={this.removeCardToRemove}
 *    confirmMessage={'Delete Card'}
 *  />
 *  <AlertDialog
 *    variant={'warning'}
 *    alertTitle={'Disconnect Zip'}
 *    isOpen={confirmDisconnectZipDialogOpen}
 *    handleClose={this.closeConfirmDisconnectZipDialog}
 *    handleConfirm={this.disconnectZip}
 *    confirmMessage={'Disconnect Zip'}
 *  />
 * ```
 */
var AlertDialog = function AlertDialog(_ref) {
  var variant = _ref.variant,
      emoji = _ref.emoji,
      alertTitle = _ref.alertTitle,
      alertMessage = _ref.alertMessage,
      confirmMessage = _ref.confirmMessage,
      cancelMessage = _ref.cancelMessage,
      isOpen = _ref.isOpen,
      handleClose = _ref.handleClose,
      handleConfirm = _ref.handleConfirm,
      disableConfirm = _ref.disableConfirm,
      hideButtons = _ref.hideButtons,
      hideEmoji = _ref.hideEmoji,
      customContent = _ref.customContent;

  var onHandleConfirm = function onHandleConfirm() {
    handleConfirm();
    handleClose();
  };

  var getAlertIcon = function getAlertIcon() {
    if (hideEmoji) return undefined;

    if (emoji) {
      return emoji;
    }

    switch (variant) {
      case _FBUIConstants.ALERT_TYPES.WARNING:
        return '😱';

      case _FBUIConstants.ALERT_TYPES.ERROR:
        return '🥺';

      case _FBUIConstants.ALERT_TYPES.CONFIRM:
        return '🤔';

      default:
        return undefined;
    }
  };

  var alertIcon = getAlertIcon();
  return /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: isOpen,
    onClose: handleClose,
    classes: {
      root: _AlertDialogModule.default.AlertDialogRoot,
      paper: _AlertDialogModule.default.AlertDialogPaper
    }
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    className: _AlertDialogModule.default.AlertDialog__header
  }, alertIcon ? /*#__PURE__*/_react.default.createElement("div", {
    className: _AlertDialogModule.default.AlertDialog__icon
  }, alertIcon) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: _AlertDialogModule.default.AlertDialog__heading
  }, alertTitle || 'Are you sure?'), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: _AlertDialogModule.default.AlertDialog__closeBtn,
    "aria-label": "close",
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, customContent ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, customContent) : /*#__PURE__*/_react.default.createElement("div", {
    className: _AlertDialogModule.default.AlertDialog__message
  }, variant === _FBUIConstants.ALERT_TYPES.WARNING ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "Warning:\xA0"), alertMessage || 'this cannot be undone') : null, variant === _FBUIConstants.ALERT_TYPES.ERROR ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "Error:\xA0"), alertMessage || 'Oops, something went wrong') : null, variant === _FBUIConstants.ALERT_TYPES.CONFIRM ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, alertMessage || 'Are you sure?') : null), /*#__PURE__*/_react.default.createElement("div", {
    className: _AlertDialogModule.default.AlertDialog__actions
  }, hideButtons ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, variant === _FBUIConstants.ALERT_TYPES.CONFIRM ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: 'secondary',
    onClick: handleClose
  }, cancelMessage || 'Cancel'), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: 'primary',
    onClick: onHandleConfirm,
    disabled: disableConfirm
  }, confirmMessage || 'Ok')) : /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: 'danger',
    onClick: onHandleConfirm,
    disabled: disableConfirm
  }, confirmMessage || 'Ok')))));
};

AlertDialog.propTypes = {
  variant: _propTypes.default.oneOf(Object.values(_FBUIConstants.ALERT_TYPES)),
  emoji: _propTypes.default.string,
  alertMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]),
  alertTitle: _propTypes.default.string,
  confirmMessage: _propTypes.default.string,
  cancelMessage: _propTypes.default.string,
  isOpen: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  handleConfirm: _propTypes.default.func.isRequired,
  disableConfirm: _propTypes.default.bool,
  hideButtons: _propTypes.default.bool,
  hideEmoji: _propTypes.default.bool,
  customContent: _propTypes.default.node
};
var _default = AlertDialog;
exports.default = _default;

//# sourceMappingURL=AlertDialog.js.map